var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"cursor",on:{"click":function($event){$event.preventDefault();return _vm.filterBy(_vm.filterItem)}}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.filterItem.id}}),_vm._v("\n    "+_vm._s(_vm.filterItem.id)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-116af090","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/cutaway/components/BadgeItem.vue
// module id = null
// module chunks = 